import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setSuccess, setWarning } from "../common/toast/toast";
import { initialize } from "redux-form";
import DateFormat from "../common/dateFormat/DateFormat";
import { retornarApenasNumeros } from "../utils/retornarApenasNumeros";

import { setFiltro as setFiltroDemandaContrato } from "../demandaContrato/demandaContratoActions";

export function setModoTela(modo, registro = {}) {
    return {
        type: "CLIENTE_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setModoTelaUC(modoUC, registroUC = {}) {
    return {
        type: "UC_MODO_TELA",
        payload: {
            modoUC: modoUC,
            registroUC: registroUC,
        },
    };
}

export function initForm(registro = {}) {
    return [initialize("clienteForm", registro)];
}

export function initUcForm(registro = {}) {
    return [initialize("unidadeConsumidoraForm", registro)];
}

export function setAguardando(aguardando) {
    return {
        type: "CLIENTE_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function getLista(usuario = {}) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            dispatch({
                type: "CLIENTE_LISTADO",
                payload: [],
            });

            dispatch(setAguardando(true));

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idUsuarioConsulta = usuario.id || usuarioLogado.id;
            const request = await axios.get(`${consts.API_URL}/cliente?id_usuario_logado=${idUsuarioConsulta}&exibir_desligados=true&exibir_clientes_sem_uc=true&id_empresa=${idEmpresa}`);
            const listaClientes = request.data || [];
            const listaClientesFiltrada = filtrarClientesUsuarioImplantacao(idUsuarioConsulta, listaClientes); // se usuario logado não for implantação retorna a lista original
            dispatch({
                type: "CLIENTE_LISTADO",
                payload: listaClientesFiltrada,
            });
        } catch (erro) {
            setError("Não foi possível carregar a lista de clientes");
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function getListaUCsCliente(id_cliente, modoTelaUC = null, registroUC = {}) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));
            const request = await axios.get(`${consts.API_URL}/unidadeConsumidora?id_cliente=${id_cliente || 0}&id_usuario_logado=${usuarioLogado.id}`);
            const itens = request.data || [];

            //adiciona propriedade de bloqueio para usuário implantação
            const cliente = getState().cliente.registro;

            //atualiza o cliente com as UCs atualizadas
            const clienteComUCsAtualizadas = { ...cliente, itens };
            const listaClientes = [clienteComUCsAtualizadas];

            //tem só o cliente carregado no formulário, usa uma lista pra reaproveitar a função filtrarClientesUsuarioImplantacao
            const listaClientesFiltrada = filtrarClientesUsuarioImplantacao(usuarioLogado, listaClientes); // se usuario logado não for implantação retorna a lista original
            dispatch(setModoTelaUC(modoTelaUC, registroUC)); //fecha o formulário de UC
            const modoTela = getState().cliente.modoTela;
            dispatch(setModoTela(modoTela, listaClientesFiltrada[0] || {}));
            dispatch(initForm(listaClientesFiltrada[0] || {}));
            // console.log("Lista de UC:", listaClientesFiltrada[0]);
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function buscarTiposContratoAtivo(idUnidadeConsumidora) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));
            const request = await axios.get(`${consts.API_URL}/demandaCompetencia/buscarTiposContratoAtivo?id_unidade_consumidora=${idUnidadeConsumidora}`);
            dispatch({
                type: "CLIENTE_TIPOS_CONTRATOS_DEMANDA_ATIVOS_UC",
                payload: request.data[0] || {},
            });
        } catch (erro) {
            setError("Não foi possível verificar quais tipos de contratos estão ativos na UC");
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
function filtrarClientesUsuarioImplantacao(usuario, listaClientes) {
    if (!usuario || !usuario.usuario_implantacao) return listaClientes;

    const clientesMapeados = listaClientes.map((cliente) => {
        //adiciona parametro bloquearEdicaoClienteUsuarioImplantacao ao cliente da lista para sumir os botoes editar, anexar e excluir
        //só pode editar um cliente se o id do usuário estiver vinculado ao id_usuario_implantacao de todas as UCs do cliente
        const bloquearEdicaoClienteUsuarioImplantacao = !cliente.itens.find((uc) => uc.id_usuario_implantacao == usuario.id);

        //cria uma propriedade que diz se a UC está vinculada ou não ao usuario implantacao
        //para que ele possa apenas ver as UCs existentes, mas possa editar a que ele cadastrou
        const unidadesConsumidoras = cliente.itens.map((uc) => {
            //se o usuario implantacao não estiver vinculado a UC ele nao poderá editá-la
            const bloquearEdicaoUcUsuarioImplantacao = uc.id_usuario_implantacao != usuario.id;
            return { ...uc, bloquearEdicaoUcUsuarioImplantacao };
        });
        return {
            ...cliente,
            bloquearEdicaoClienteUsuarioImplantacao,
            itens: unidadesConsumidoras,
        };
    });
    return clientesMapeados;
}

export function salvarUC(registro, callback) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));

            const { remotaVirouGeradora, id_estado, id_atividade, ...registroFormatado } = registro;
            registroFormatado.data_nascimento = registro.data_nascimento
                ? String(registro.data_nascimento).substring(0, 10)
                : null;

            registroFormatado.competencia_inicio_mercado_livre = registro.competencia_inicio_mercado_livre
                ? String(registro.competencia_inicio_mercado_livre).replace(/_/g, "")
                : null;

            registroFormatado.competencia_inicio_geracao = registro.competencia_inicio_geracao ? String(registro.competencia_inicio_geracao).replace(/_/g, "") : null;
            registroFormatado.percentual_geracao = registroFormatado.percentual_geracao || 0;
            registroFormatado.percentual_geracao_externa = registroFormatado.percentual_geracao_externa || 0;
            registroFormatado.data_desligamento = registroFormatado.data_desligamento ? DateFormat.formatarDataTelaParaSql(registroFormatado.data_desligamento) : null;

            //VALIDA UF E ATIVIDADE DA UC PARA SETAR A TRIBUTAÇÂO----------------------------------------------------------------------------

            //para novas UCs exige id_estado e id_atividade
            if (!registroFormatado.id && (!id_estado || !id_atividade)) {
                setError("Informe a UF e a atividade da UC");
                return {};
            }

            if (remotaVirouGeradora && !registroFormatado.competencia_inicio_geracao) {
                setError("Para transformar a Remota em Geradora precisa definir o mês de início de geração");
                return {};
            }

            //Deve também encontrar uma tributacao pra UF e atividade selecionada
            const listaTributacao = getState().tributacao.lista;
            const ucTributacaoNaoLocalizada =
                (id_estado || id_atividade) && !listaTributacao.find((tributacao) => tributacao.id_estado == id_estado && tributacao.id_atividade == id_atividade);

            if (ucTributacaoNaoLocalizada) {
                setError(`Não foi localizada a tributação referente a UF e a atividade da UC "${ucTributacaoNaoLocalizada.nome}"`);
                return {};
            }

            //remove id_estado e id_atividade, para incluir id_tributacao, que é o atributo vinculado a UC
            const tributacao = listaTributacao.find((tributacao) => tributacao.id_estado == id_estado && tributacao.id_atividade == id_atividade);

            registroFormatado.id_tributacao = tributacao ? tributacao.id : null;
            registroFormatado.id_unidade_geradora = registroFormatado.id_unidade_geradora || null;
            //----------------------------------------------------------------------------------------------------------------------------------
            if (!registroFormatado.id) {
                // console.log("Incluindo UC:", registroFormatado);
                await axios.post(`${consts.API_URL}/unidadeConsumidora`, { ...registroFormatado, id_usuario_inclusao: usuarioLogado.id });
                await dispatch(getListaUCsCliente(registroFormatado.id_cliente));
                setSuccess("Unidade Consumidora incluída com sucesso.");
            } else {
                const ucOriginal = getState().cliente.registroUC;

                // console.log("Alterando UC:", registroFormatado);
                await axios.put(`${consts.API_URL}/unidadeConsumidora`, { ...registroFormatado, id_usuario_alteracao: usuarioLogado.id });

                //quando altera a sazonalidade da UC busca se existe um contrato com sazonalidade diferente, para alertar que o contrato deve ser encerrado
                if (!!ucOriginal.contrato_demanda_sazonal != !!registroFormatado.contrato_demanda_sazonal) {
                    const retorno = await axios.get(
                        `${consts.API_URL}/demandaContrato/buscarContratoDemandaPorUCSazonalidade?id_unidade_consumidora=${ucOriginal.id}&contrato_demanda_sazonal=${ucOriginal.contrato_demanda_sazonal}`
                    );

                    if (retorno.data.length) {
                        if (
                            setWarning(
                                `Você alterou a sazonalidade da UC para ${registroFormatado.contrato_demanda_sazonal ? ' "Sazonal" ' : ' "Não Sazonal" '}, porém a UC possui ${
                                    retorno.data.length
                                } ${retorno.data.length > 1 ? "contratos de demanda" : "contrato de demanda"} ${
                                    ucOriginal.contrato_demanda_sazonal ? ' "Sazonal"' : ' "Não Sazonal"'
                                }. Encerre os contratos que divergem do tipo de sazonalidade definido na UC.`
                            )
                        ) {
                            dispatch(
                                setFiltroDemandaContrato({
                                    ...getState().demandaContrato.filtro,
                                    id_unidade_consumidora: ucOriginal.id,
                                })
                            );
                            setTimeout(() => (window.location.href = "#/demanda-contrato"), 2000);
                        }
                    }
                }

                setSuccess("Unidade Consumidora alterada com sucesso.");

                if (callback) {
                    setTimeout(callback, 1000);
                }
            }
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvarUCAgua({ registro, callback }) {
    // console.log("ENTROU NA ACTION DE SALVAR AGUA O REGISTRO", registro);
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            dispatch(setAguardando(true));
            const { id_cliente, id_unidade_consumidora } = registro;
            //----------------------------------------------------------------------------------------------------------------------------------
            if (!registro.id) {
                // console.log("Incluindo UC Água:", registro);
                await axios.post(`${consts.API_URL}/unidadeConsumidoraAgua`, { ...registro, id_usuario_inclusao: usuarioLogado.id });
                await dispatch(getListaUCsAgua({ id_cliente, id_unidade_consumidora })); //buscar lista de ucs de agua pelo cliente e uc
                setSuccess("Unidade Consumidora de Água incluída com sucesso.");
            } else {
                // console.log("Alterando UC Água:", registro);
                await axios.put(`${consts.API_URL}/unidadeConsumidoraAgua`, { ...registro, id_usuario_alteracao: usuarioLogado.id });
                await dispatch(getListaUCsAgua({ id_cliente, id_unidade_consumidora }));
                setSuccess("Unidade Consumidora de Água alterada com sucesso.");
            }
            if (callback) callback();
        } catch (error) {
            console.error(error);
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluirUCAgua(registro) {
    // console.log("ENTROU NA ACTION DE EXCLUIR AGUA O REGISTRO", registro);
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            if (!parseInt(registro.id)) {
                setError("ID inálido, não será possível excluir o registro");
                return {};
            }
            // console.log("Excluindo UC Água:", registro);
            dispatch(setAguardando(true));
            await axios.delete(`${consts.API_URL}/unidadeConsumidoraAgua?id=${registro.id}&id_usuario_alteracao=${usuarioLogado.id}`);

            const { id_cliente, id_unidade_consumidora } = registro;
            await dispatch(getListaUCsAgua({ id_cliente, id_unidade_consumidora }));
            setSuccess(`Unidade Consumidora de água excluida com sucesso.`);
        } catch (error) {
            console.error(error);
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function getListaUCsAgua({ id_cliente = 0, id_unidade_consumidora = 0 }) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const request = await axios.get(`${consts.API_URL}/unidadeConsumidoraAgua?id_cliente=${id_cliente}&id_unidade_consumidora=${id_unidade_consumidora}`);
            const unidades_consumidoras_agua = request.data || [];

            const modoTela = getState().cliente.modoTelaUC;
            const registroUC = getState().cliente.registroUC;
            const registroAtualizado = { ...registroUC, unidades_consumidoras_agua };
            dispatch(setModoTelaUC(modoTela, registroAtualizado));
            dispatch(initUcForm(registroAtualizado));
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function alterarPropriedadeUC(registro) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const cpfCnpjRegex = /^(?:\d{11}|\d{14})$/;
            const onlyNumbersRegex = /^\d+$/;

            //valida campo cpf_cnpj
            if (registro.propriedade === "cpf_cnpj") {
                if (!cpfCnpjRegex.test(registro.cpf_cnpj)) {
                    setError(`O formato do CPF/CNPJ não é valido`);
                    return {};
                }
            }
            
            //validação mercado livre -------------------------------------------------------------
            if (registro.propriedade === "id_plataforma_mercado_livre" && !registro.id_plataforma_mercado_livre) {
                setError(`Selecione a plataforma de mercado livre`);
                return {};
            }
            if (registro.propriedade === "usuario_mercado_livre" && !registro.usuario_mercado_livre && !registro.integracao_mercado_livre_por_email) {
                setError(`Informe o login da plataforma de mercado livre`);
                return {};
            }
            if (registro.propriedade === "senha_mercado_livre" && !registro.senha_mercado_livre && !registro.integracao_mercado_livre_por_email) {
                setError(`Informe a senha da plataforma de mercado livre`);
                return {};
            }

            //validação do acesso a concessionária---------------------------------------------------

            const concessionarias = {
                1: "CERMISSÕES",
                2: "RGE",
                3: "CEEE",
                4: "CERILUZ",
                5: "CERTHIL",
                6: "COOPERLUZ",
                7: "NEOENERGIA",
                8: "COPREL",
                9: "DEMEI",
                12: "EQUATORIAL",
                15: "ELETROCAR",
            };
            //valida senha concessionária
            if (registro.propriedade === "senha" && !registro.senha) {
                setError(`Informe a senha de acesso à concessionária`);
                return {};
            }

            if (registro.propriedade === "senha" && registro.id_concessionaria === 12 && !cpfCnpjRegex.test(registro.senha)) {
                setError(`A senha da concessionária EQUATORIAL deve ser um CPF/CNPJ sem pontuação`);
                return {};
            }

            if (registro.propriedade === "usuario" && registro.id_concessionaria) {
                if (String(registro.usuario).length > 50) {
                    setError(`O login da concessinária não pode ter mais de 50 caracteres`);
                    return {};
                }

                if ([3, 7, 8].includes(registro.id_concessionaria)) {
                    if (!cpfCnpjRegex.test(registro.usuario)) {
                        setError(`O login da concessinária ${concessionarias[registro.id_concessionaria]} deve ser um CPF/CNPJ sem pontuação`);
                        return {};
                    }
                } else if ([2].includes(registro.id_concessionaria)) {
                    if (!emailRegex.test(registro.usuario)) {
                        setError(`O login da concessinária ${concessionarias[registro.id_concessionaria]} deve ser um e-mail válido`);
                        return {};
                    }
                } else if ([5, 6, 9, 12].includes(registro.id_concessionaria)) {
                    if (!onlyNumbersRegex.test(registro.usuario)) {
                        setError(`O login da concessinária ${concessionarias[registro.id_concessionaria]} deve ser o código da UC (somente números)`);
                        return {};
                    }
                    if ([9].includes(registro.id_concessionaria) && (!onlyNumbersRegex.test(registro.digito) || String(registro.digito).length != 1)) {
                        setError(`O dígito da concessinária ${concessionarias[registro.id_concessionaria]} deve ser um número entre 0 e 9`);
                        return {};
                    }
                } else if ([1, 4, 15].includes(registro.id_concessionaria)) {
                    if (!cpfCnpjRegex.test(registro.usuario) && !emailRegex.test(registro.usuario)) {
                        setError(`O login da concessinária ${concessionarias[registro.id_concessionaria]} deve ser um CPF/CNPJ sem pontuação ou um e-mail válido`);
                        return {};
                    }
                }
            }

            //demei manda digito também ao alterar usuario
            if (registro.propriedade === "usuario" && registro.id_concessionaria == 9) {
                await axios.put(`${consts.API_URL}/unidadeConsumidora/alterarPropriedadeUC`, {
                    id: registro.id,
                    propriedade: "digito",
                    valor: registro.digito,
                    id_usuario_alteracao: usuarioLogado.id,
                });
            }
            await axios.put(`${consts.API_URL}/unidadeConsumidora/alterarPropriedadeUC`, {
                id: registro.id,
                propriedade: registro.propriedade,
                valor: registro[registro.propriedade],
                id_usuario_alteracao: usuarioLogado.id,
            });
            dispatch(setAguardando(true));
            setSuccess(`Unidade Consumidora alterada com sucesso.`);
            if (registro.callback) {
                registro.callback();
            }
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function reativarUC(registro) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            // console.log("Reativando UC:", registro);
            dispatch(setAguardando(true));
            await axios.put(`${consts.API_URL}/unidadeConsumidora/reativar`, { id: registro.id, id_usuario_alteracao: usuarioLogado.id });
            await dispatch(getListaUCsCliente(registro.id_cliente));
            setSuccess(`Unidade Consumidora reativada com sucesso.`);
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
export function definirIdUsuarioImplantacaoTodasUCs({ id_cliente, id_usuario_implantacao_todas_uc, callback }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            if (!id_usuario_implantacao_todas_uc) {
                setError("Selecione um usuário implantação");
                return {};
            }
            dispatch(setAguardando(true));
            await axios.put(`${consts.API_URL}/unidadeConsumidora/definirIdUsuarioImplantacaoTodasUCs`, {
                id_cliente,
                id_usuario_implantacao_todas_uc,
                id_usuario_alteracao: usuarioLogado.id,
            });
            await dispatch(getListaUCsCliente(id_cliente));
            setSuccess(`Usuário de implantação alterado com sucesso`);
            callback();
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function removerIdUsuarioImplantacaoTodasUCs({ id_cliente, callback }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));
            await axios.put(`${consts.API_URL}/unidadeConsumidora/removerIdUsuarioImplantacaoTodasUCs`, {
                id_cliente,
                id_usuario_alteracao: usuarioLogado.id,
            });
            await dispatch(getListaUCsCliente(id_cliente));
            setSuccess(`Usuário de implantação removido com sucesso`);
            callback();
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluirUC(registro) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            // console.log("Excluindo UC:", registro);
            dispatch(setAguardando(true));
            await axios.delete(
                `${consts.API_URL}/unidadeConsumidora?id=${registro.id}&exclusao_definitiva=${registro.exclusao_definitiva}&id_usuario_alteracao=${usuarioLogado.id}`
            );
            await dispatch(getListaUCsCliente(registro.id_cliente));
            setSuccess(`Unidade Consumidora ${registro.exclusao_definitiva ? "excluida" : "inativada"} com sucesso.`);
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro, callback) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            dispatch(setAguardando(true));
            const registroSemPontuacao = removerPontuacaoCamposCliente(registro);

            if (!registroSemPontuacao.id) {
                const retorno = await axios.post(`${consts.API_URL}/cliente`, { ...registroSemPontuacao, id_usuario_inclusao: usuarioLogado.id });
                setSuccess(`Cliente incluido com sucesso.`);
                if (callback) {
                    setTimeout(() => callback(retorno), 1000);
                }
            } else {
                await axios.put(`${consts.API_URL}/cliente`, { ...registroSemPontuacao, id_usuario_alteracao: usuarioLogado.id });
                setSuccess(`Cliente alterado com sucesso.`);
                if (callback) {
                    setTimeout(callback, 500);
                }
            }
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function reativar(registro) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            // console.log("Reativando UC:", registro);
            dispatch(setAguardando(true));
            // console.log(registro);
            await axios.put(`${consts.API_URL}/cliente/reativar`, { id: registro.id, id_usuario_alteracao: usuarioLogado.id });
            setSuccess(`Cliente reativado com sucesso.`);
            await dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function gerarAcesso(registro) {
    return (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        const login = registro.cpf ? retornarApenasNumeros(registro.cpf) : retornarApenasNumeros(registro.cnpj);
        if (!registro.id) {
            setError("Informe o ID do cliente para gerar o acesso");
            return {};
        }
        if (!registro.id_empresa) {
            setError("Informe a para gerar o acesso");
            return {};
        }
        if (!registro.nome) {
            setError("Informe o Nome para gerar o acesso");
            return {};
        }
        if (!login) {
            setError("Informe o CPF/CNPJ para gerar o acesso");
            return {};
        }

        axios
            .post(`${consts.API_URL}/usuario`, {
                nome: registro.nome,
                login,
                administrador: false,
                acesso_cliente: true,
                id_cliente: registro.id,
                id_empresa: registro.id_empresa,
                senha: Math.random().toString(36).substring(7),
                id_usuario_logado: usuarioLogado.id,
            })
            .then((resp) => {
                setSuccess("Operação Realizada com sucesso.");
                dispatch(
                    initForm({
                        ...registro,
                        id_usuario: resp.data.id,
                        login: resp.data.login,
                        senha_cliente: resp.data.senha_cliente,
                    })
                );
                dispatch(
                    setModoTela("cadastro", {
                        ...registro,
                        id_usuario: resp.data.id,
                        login: resp.data.login,
                        senha_cliente: resp.data.senha_cliente,
                    })
                );
                dispatch(getLista());
            })
            .catch((e) => {
                setErroAPI(e);
            });
    };
}

export function excluir(registro) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            // console.log("Excluindo UC:", registro);
            dispatch(setAguardando(true));
            await axios.delete(`${consts.API_URL}/cliente?id=${registro.id}&desligado=${registro.desligado}&id_usuario_alteracao=${usuarioLogado.id}`);
            setSuccess(`Cliente ${registro.desligado ? "inativado" : "excluido"} com sucesso.`);
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaCidade() {
    const request = axios.get(`${consts.API_URL}/cidade/listarSelect`);
    return {
        type: "CLIENTE_CIDADE_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaUsuarioAdministrador() {
    const request = axios.get(`${consts.API_URL}/usuario/listarSelectAdministrador`);
    return {
        type: "CLIENTE_USUARIO_ADMINISTRADOR_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaUsuarioAdministradorPorEmpresa(id_empresa) {
    return async (dispatch) => {
        const resposta = await axios.get(`${consts.API_URL}/usuario/listarSelectAdministrador?id_empresa=${id_empresa}`);
        dispatch({
            type: "CLIENTE_USUARIO_ADMINISTRADOR_EMPRESA_SELECT_LISTADO",
            payload: { id_empresa, usuarios: resposta.data || [] },
        });
    };
}

export function getListaUsuarioAdministradorVinculadoCliente() {
    const request = axios.get(`${consts.API_URL}/usuario/listarSelectAdministradorVinculadoCliente`);
    return {
        type: "CLIENTE_USUARIO_ADMINISTRADOR_VINCULADO_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaClienteSelect() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora(id_tipo_concessionaria) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            let resposta = { data: [] };
            dispatch({
                type: "CLIENTE_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: resposta,
            });

            //ENERGIA
            if (id_tipo_concessionaria == 1) {
                resposta = await axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_usuario_logado=${usuarioLogado.id}`);
            }

            //ÁGUA
            if (id_tipo_concessionaria == 2) {
                resposta = await axios.get(`${consts.API_URL}/unidadeConsumidoraAgua/listarSelect?id_usuario_logado=${usuarioLogado.id}`);
            }

            dispatch({
                type: "CLIENTE_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: resposta,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaConcessionaria() {
    const request = axios.get(`${consts.API_URL}/concessionaria/listarSelect`);
    return {
        type: "CLIENTE_CONCESSIONARIA_SELECT_LISTADO",
        payload: request,
    };
}
export function getListaConcessionariaAgua() {
    const request = axios.get(`${consts.API_URL}/concessionaria-agua/listar-select`);
    return {
        type: "CLIENTE_CONCESSIONARIA_AGUA_SELECT_LISTADO",
        payload: request,
    };
}
export function getListaTipoTransformador() {
    const request = axios.get(`${consts.API_URL}/tipo-transformador/listar-select`);
    return {
        type: "CLIENTE_TIPO_TRANSFORMADOR_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaPlataformaMercadoLivre() {
    const request = axios.get(`${consts.API_URL}/plataforma-mercado-livre/listar-select`);
    return {
        type: "CLIENTE_PLATAFORMA_MERCADO_LIVRE_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaGrupoFaturamento() {
    const request = axios.get(`${consts.API_URL}/grupoFaturamento/listarSelect`);
    return {
        type: "CLIENTE_GRUPO_FATURAMENTO_SELECT_LISTADO",
        payload: request,
    };
}
export function getListaSubgrupoFaturamento() {
    const request = axios.get(`${consts.API_URL}/subgrupoFaturamento/listarSelect`);
    return {
        type: "CLIENTE_SUBGRUPO_FATURAMENTO_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaModalidadeTarifaria() {
    const request = axios.get(`${consts.API_URL}/modalidadeTarifaria/listarSelect`);
    return {
        type: "CLIENTE_MODALIDADE_TARIFARIA_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaTipoMedicao() {
    const request = axios.get(`${consts.API_URL}/tipoMedicao/listarSelect`);
    return {
        type: "CLIENTE_TIPO_MEDICAO_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaTipoMercado() {
    const request = axios.get(`${consts.API_URL}/tipoMercado/listarSelect`);
    return {
        type: "CLIENTE_TIPO_MERCADO_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaModalidadeMercadoLivre() {
    const request = axios.get(`${consts.API_URL}/modalidadeMercadoLivre/listarSelect`);
    return {
        type: "CLIENTE_MODALIDADE_MERCADO_LIVRE_SELECT_LISTADO",
        payload: request,
    };
}
export function getListaTipoEnergiaMercadoLivre() {
    const request = axios.get(`${consts.API_URL}/tipoEnergiaMercadoLivre/listarSelect`);
    return {
        type: "CLIENTE_TIPO_ENERGIA_MERCADO_LIVRE_SELECT_LISTADO",
        payload: request,
    };
}
export function initFormAnexo(registro = {}) {
    return [initialize("clienteAnexoForm", registro)];
}

export function getListaAnexo(id_cliente) {
    const request = axios.get(`${consts.API_URL}/clienteAnexo?id_cliente=${id_cliente}`);
    return {
        type: "CLIENTE_ANEXO_LISTADO",
        payload: request,
    };
}

export function salvarAnexo(registro) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));

        if (!registro.id) {
            axios
                .post(`${consts.API_URL}/clienteAnexo`, {
                    ...registro,
                })
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getListaAnexo(registro.id_cliente));
                    dispatch(setModoTela("listaAnexo", getState().cliente.registro));
                    dispatch(setAguardando(false));
                })
                .catch((e) => {
                    setErroAPI(e);
                    dispatch(setAguardando(false));
                });
        } else {
            axios
                .put(`${consts.API_URL}/clienteAnexo`, {
                    ...registro,
                })
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getListaAnexo(registro.id_cliente));
                    dispatch(setModoTela("listaAnexo", getState().cliente.registro));
                    dispatch(setAguardando(false));
                })
                .catch((e) => {
                    setErroAPI(e);
                    dispatch(setAguardando(false));
                });
        }
    };
}

export function excluirAnexo(registro) {
    return (dispatch, getState) => {
        axios
            .delete(`${consts.API_URL}/clienteAnexo?id=${registro.id}`)
            .then((resp) => {
                setSuccess("Operação Realizada com sucesso.");
                dispatch(getListaAnexo(registro.id_cliente));
                dispatch(setModoTela("listaAnexo", getState().cliente.registro));
            })
            .catch((e) => {
                setErroAPI(e);
            });
    };
}

function removerPontuacaoCamposCliente(registro) {
    const registroSemPontuacao = JSON.parse(JSON.stringify(registro));
    registroSemPontuacao.cpf = retornarApenasNumeros(registro.cpf);
    registroSemPontuacao.cnpj = retornarApenasNumeros(registro.cnpj);
    registroSemPontuacao.faturamento_cpf = retornarApenasNumeros(registro.faturamento_cpf);
    registroSemPontuacao.faturamento_cnpj = retornarApenasNumeros(registro.faturamento_cnpj);
    registroSemPontuacao.faturamento_telefone = retornarApenasNumeros(registro.faturamento_telefone);
    registroSemPontuacao.faturamento_celular = retornarApenasNumeros(registro.faturamento_celular);
    registroSemPontuacao.faturamento_cep = retornarApenasNumeros(registro.faturamento_cep);
    registroSemPontuacao.telefone_residencial = retornarApenasNumeros(registro.telefone_residencial);
    registroSemPontuacao.telefone_celular = retornarApenasNumeros(registro.telefone_celular);
    return registroSemPontuacao;
}

//usada para validar o acesso do usuario implantação
export async function getUcValidarUsuarioImplantacao() {
    return async (dispatch, getState) => {
        const request = await axios.get(`${consts.API_URL}/unidadeConsumidora/listar`);
        dispatch({
            type: "UNIDADE_CONSUMIDORA_LISTADO",
            payload: request,
        });
    };
}
